import Image1 from "./images/desktop-image-hero-1.jpg";
import Image2 from "./images/desktop-image-hero-2.jpg";
import Image3 from "./images/desktop-image-hero-3.jpg";

const data = [
  {
    id: 1,
    img: Image1,
    title: "Discover innovative ways to decorate",
    info: `We provide unmatched quality, comfort, and style for property owners across the country.
        Our expert combine form and function in bringing your vision life. Create a room in your own style with our collection and make your
        property a reflection of you and what you love.
        `,
  },
  {
    id: 1,
    img: Image2,
    title: "We are available all across the globe.",
    info: `With stores all over the world, it's easy for you to find furniture for your home or place of business. Locally, we’re in most major cities throughout the country. Find the branch nearest you using our store locator. Any questions? Don't hesitate to contact us today.
        `,
  },
  {
    id: 1,
    img: Image3,
    title: "Manufactured with the best materials.",
    info: `Our modern furniture store provide a high level of quality. Our company has invested in advanced technology to ensure that every product is made as perfect and as consistent as possible. With three decades of experience in this industry, we understand what customers want for their home and office.
        `,
  },
];

export default data;
